import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "signature-pad",
  class: "signature-pad align-self-center"
}
const _hoisted_2 = { class: "signature-pad--footer" }
const _hoisted_3 = { class: "signature-pad--actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "signature-pad--body" }, [
      _createElementVNode("canvas")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "description" }, "Sign above with your mouse", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "action-button clear",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearPad && _ctx.clearPad(...args))),
          "data-action": "clear"
        }, "Clear"),
        _createElementVNode("button", {
          type: "button",
          class: "action-button",
          "data-action": "undo",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.undoPad && _ctx.undoPad(...args)))
        }, "Undo")
      ])
    ])
  ]))
}